import { render } from "./resetPasswordMutation.vue?vue&type=template&id=2f2da749"
import script from "./resetPasswordMutation.vue?vue&type=script&lang=js"
export * from "./resetPasswordMutation.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__